import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { AtividadeRefCardInfoModule } from '../../ref/card-info';
import { AtividadeTipoSelectModule } from '../../tipo/select';
import { UsuarioSelectModule } from '../../../usuario/select';

import { AtividadeRetornoFormComponent } from './atividade-retorno-form.component';

@NgModule({
    imports: [
        SharedModule,
        TimepickerModule,
        AtividadeRefCardInfoModule,
        AtividadeTipoSelectModule,
        UsuarioSelectModule
    ],
    declarations: [
        AtividadeRetornoFormComponent
    ],
    exports: [
        AtividadeRetornoFormComponent
    ]
})
export class AtividadeRetornoFormModule { }
